<template>
    <div id="ComponentInventoryCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemHeader" v-if="$route.params.id > 0">Update Part Inventory</span>
                    <span class="page-title" id="itemHeader" v-else>Add Part Inventory</span>
                    <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-inventory-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ComponentInventoryForm">
                                <div class="form-row row-cols-md-4">
                                    <div class="col form-group">
                                        <label class="control-label require" for="component_id">Part:</label>
                                        <v-select :disabled="!isComponentFilterable" @input="changeItem" v-model="component_id"  name="component_id" label="text" :filterable="isComponentFilterable" :options="itemArr" @search="onSearchComponent" placeholder="Search Part"  class="custom-ci-auto-search close-remove">
                                            <template slot="no-options">
                                                Search Part...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ component_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select :disabled="!isComponentFilterable" v-model="location_id" @change="changeLocation($event)" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" :filterable="isComponentFilterable">
                                        </v-select>
                                        <div class="field-error">{{locationerrors}}</div>
                                    </div>
                                     <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label for="is_default" class="checkbox-custom">Is Default
                                            <input type="checkbox" v-model="is_default" id="is_default" name="is_default" v-on:click="isDefault($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="selectedParts.length > 0">
                                    <div class="form-row row-cols-md-4 row-cols-1 permission-lists pl-1 pr-3">
                                        <div class="permission-inside-list">
                                            <template v-for="(mp, index) in selectedParts">
                                                <div class="form-row" :key="index">
                                                    <label class="col">{{mp.text}}</label>
                                                    <div class="col" v-if="$route.params.id == undefined">
                                                        <a href="javascript:void(0)" v-on:click.prevent="removeSelectedPart(index,mp)"> <i class="fp-remove color-red"></i> </a>
                                                    </div>
                                                </div>
                                                <p :key="index+'p'">&nbsp;&nbsp;</p>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-row row-cols-md-4">

                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id"  @input="changeWarehouse($event)" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr">
                                        </v-select>
                                        <div class="field-error">{{warehouseerrors}}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label" for="location_id">R/S/B:</label>
                                        <v-select v-model="rsb_id" name="rsb_id" placeholder="R/S/B."
                                                label="text"
                                                :options="rsbArr">
                                        </v-select>
                                        <div class="field-error">{{rsb_iderror}}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label require" for="stock_unit_id">Stock UOM:</label>
                                        <v-select v-model="stock_unit_id" name="stock_unit_id" placeholder="Select Stock UOM."
                                                label="text"
                                                :options="stockunitArr">
                                        </v-select>
                                        <div class="field-error">{{ stockuniterrors }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="purchase_unit_id">Purchase UOM:</label>
                                        <v-select v-model="purchase_unit_id" name="purchase_unit_id" placeholder="Select Purchase UOM."
                                                label="text"
                                                :options="purchaseunitArr">
                                        </v-select>
                                        <div class="field-error">{{ purchaseuniterrors }}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label" for="onhand_min_qty">Onhand Min Qty:</label>
                                        <input type="text" class="form-control" v-model="onhand_min_qty" id="onhand_min_qty" placeholder="Enter Onhand Min Qty" name="onhand_min_qty" @keypress="isAmountCheck($event)">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="onhand_max_qty">Onhand Max Qty:</label>
                                        <input type="text" class="form-control" v-model="onhand_max_qty" id="onhand_max_qty" placeholder="Enter Onhand Max Qty" name="onhand_max_qty" @keypress="isAmountCheck($event)">
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="location_row">Location Row:</label>
                                        <input type="text" class="form-control" v-model="location_row" id="location_row" placeholder="Enter Location Row" name="location_row">
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="location_bin">Location Bin:</label>
                                        <input type="text" class="form-control" v-model="location_bin" id="location_bin" placeholder="Enter Location Bin" name="location_bin">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_shelf">Location Shelf:</label>
                                        <input type="text" class="form-control" v-model="location_shelf" id="location_shelf" placeholder="Enter Location Shelf" name="location_shelf">
                                    </div> -->
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateComponentInventoryBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateComponentInventoryBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                        <i class="fp-add"> </i>  Add
                                    </button>
                                    <button type="submit" id="cancelItemBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
export default {
  name: "ItemCreate",

  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Part Transaction | " +process.env.COPYRIGHT_NAME : "Add Part Transaction | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    vendor_id: null,
    vendorArr: [],
    quantity: 0,
    location_id: null,
    locationArr: [],
    location_row: "",
    location_shelf: "",
    location_bin: "",
    loading:false,
    locationerrors:'',
    base_price:0,
    base_price_error_msg:'',
    warehouse_id:'',
    warehouseerrors:'',
    component_id:'',
    component_error_msg:'',
    itemArr:[],
    warehouseArr:[],
    bill_item_Id:'',
    billItemArr:[],
    woCompArr:[],
    wo_comp_id:'',
    isComponentFilterable:true,
    rsbArr:[],
    rsb_id:'',
    onhand_min_qty:'',
    onhand_max_qty:'',
    selectedParts:[],
    rsb_iderror:'',
    stock_unit_id: null,
    stockunitArr: [],
    stockuniterrors: "",
    purchase_unit_id: null,
    purchaseuniterrors: "",
    purchaseunitArr: [],
    disableSMou:false,
    disableMou:false,
    is_default:false,
    is_fuel_product:false,

  }),
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  watch:{
    //check permission change
    permissions: function (permissions) {

        var self = this;
        if (permissions.length > 0) {
            for (const element of permissions) {
              if (self.velocity_env == "velev" || self.velocity_env == "velev_test") {
                if (element.name == 'ev_add_inventory' ) {
                    self.cantAccessPage = true;
                }
              }else{
                if (element.name == 'add_component_transaction' ) {
                    self.cantAccessPage = true;
                }
              }
            }
        }

    }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        // console.log("Default " + self.expenseValue);
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {

            self.loadItem();
            self.isComponentFilterable = false;
        } else {
            self.isComponentFilterable = true;
        }
        this.loadFieldData(['location','measurementUnit']);
        if (self.location_id !== null){
          if (self.is_fuel_product){
            self.loadFieldData(['fuel_warehouse'],self.location_id.value);
          }else{
            self.loadFieldData(['non_fuel_warehouse'],self.location_id.value);
          }
        }else{
          if (self.is_fuel_product){
            self.loadFieldData(['fuel_warehouse'],'');
          }else{
            self.loadFieldData(['non_fuel_warehouse'],'');
          }
        }

        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            //self.fetchInventory();
        }else{
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null && userObj["location_id"] != null){
                self.location_id =  {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};
            }
        }
  },
  methods: {

    changeItem:function(){
        var self = this;
        self.component_error_msg = '';
        if (self.component_id != null && self.component_id.mUnitId != undefined){
            self.purchase_unit_id = {text:self.component_id.mUnitName+' ('+self.component_id.mUnitCode+')',value:self.component_id.mUnitId};
            // this.disableMou = true;
        }else{
            // this.disableMou = false;
            self.purchase_unit_id = '';
        }
        if (self.component_id != null && self.component_id.smUnitId != undefined){
            self.stock_unit_id = {text:self.component_id.smUnitName+' ('+self.component_id.smUnitCode+')',value:self.component_id.smUnitId};
            // this.disableSMou = true;
        }else{
            // this.disableSMou = false;
            self.stock_unit_id = '';
        }
        if (self.selectedParts.length >= 1){
          if (self.selectedParts[0]["itemCategoryCode"] === "FUEL" || self.selectedParts[0]["itemCategoryCode"] === "FUELNS"){
            self.is_fuel_product = true;
            if (self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS"){
              self.selectedParts.push(self.component_id);
            }else{
              self.component_error_msg = 'cannot add fuel and non fuel parts at the same time'
            }
          }else{
            self.is_fuel_product = false;
            if (self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS"){
              self.component_error_msg = 'cannot add fuel and non fuel parts at the same time'
            }else{
              self.selectedParts.push(self.component_id);
            }
          }
        }else{
          self.is_fuel_product = self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS";
          self.selectedParts.push(self.component_id);
        }
        setTimeout(function(){
            self.component_id = null;
            self.itemArr = [];
        }, 100);
        // return;
    },
    removeSelectedPart(index,part) {
        var self = this;
        if (self.selectedParts[index] != undefined && self.selectedParts[index] != null) {
            self.selectedParts.splice(index,1);
        }
        if (self.selectedParts[index - 1] != undefined){
            if (self.selectedParts[index - 1].mUnitId != undefined){
                this.purchase_unit_id = {text:self.selectedParts[index - 1].mUnitName+' ('+self.selectedParts[index - 1].mUnitCode+')',value:self.selectedParts[index - 1].mUnitId};
                // this.disableMou = true;
            }else{
                // this.disableMou = false;
            }
            if (self.selectedParts[index - 1].smUnitId != undefined){
                this.stock_unit_id = {text:self.selectedParts[index - 1].smUnitName+' ('+self.selectedParts[index - 1].smUnitCode+')',value:self.selectedParts[index - 1].smUnitId};
                // this.disableSMou = true;
            }else{
                // this.disableSMou = false;
            }
        }
        if (self.selectedParts.length <= 0){
          self.location_id = null;
        }

    },
    onSearchVendor(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },
    onSearchComponent(search, loading) {
        var self = this;
        if (search != null && search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'item', '');
        }
    },

    BackItemList() {
      var self = this;

        self.$router.push("/pdc-stock/list");

    },

    CreateComponentTransaction(flag) {
        var self = this;
        var error = false;

        self.warehouseerrors = "";
        self.locationerrors = "";
        self.base_price_error_msg = '';
        self.rsb_iderror = '';

        // if (!self.selectedParts.length || self.selectedParts == null || !self.selectedParts == undefined) {

        //     self.component_error_msg = "Component Required.";
        //     error = true;
        // }
        if(self.selectedParts == null || !self.selectedParts.length) {
            self.component_error_msg = "Component Required.";
            error = true;
        }
        if (self.location_id == null || self.location_id == '' || !self.location_id.value) {
            self.locationerrors = "Location Required.";
            error = true;
        }

       if (self.warehouse_id == null || self.warehouse_id == '' || !self.warehouse_id.value) {
            self.warehouseerrors = "Warehouse Required.";
            error = true;
        }

        // if (self.rsb_id == null || self.rsb_id == '' || !self.rsb_id.value) {
        //     self.rsb_iderror = "R/S/B Required.";
        //     error = true;
        // }
          if (self.purchase_unit_id == null || self.purchase_unit_id == '' || !self.purchase_unit_id.value) {
            self.purchaseuniterrors = "Purchase Unit Required.";
            error = true;
        }
          if (self.stock_unit_id == null || self.stock_unit_id == '' || !self.stock_unit_id.value) {
            self.stockuniterrors = "Stock Unit Required.";
            error = true;
        }

        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateComponentInventoryBtn").val("Updating ...");
                $("#CreateComponentInventoryBtn").prop("disabled", true);
                $("#cancelItemBtn").prop("disabled",true);
            }

            var fields = $("#ComponentInventoryForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            // if(self.component_id == null) {
            //     fields.push({ name: "item_id", value: '' });
            // } else {
            //     fields.push({ name: "item_id", value: self.component_id.value });
            // }

            if(self.selectedParts == null || !self.selectedParts.length) {
                fields.push({ name: "items", value: '' });
            } else {
                fields.push({ name: "items", value: JSON.stringify(self.selectedParts) });
            }

            if (self.location_id == null) {
                fields.push({name: "location_id", value: ""});
            } else{
                fields.push({name: "location_id", value: self.location_id.value});
            }

            fields.push({ name: "warehouse_id", value: self.warehouse_id.value });

            if (self.rsb_id == null) {
                fields.push({name: "rsb_id", value: ""});
            } else{
                fields.push({ name: "rsb_id", value: self.rsb_id.value });
            }
            fields.push({ name: "purchase_unit_id", value: self.purchase_unit_id.value });
            fields.push({ name: "stock_unit_id", value: self.stock_unit_id.value });
            if(self.is_default == true){
                fields.push({ name: "is_default", value:1});
            }else{
                fields.push({ name: "is_default", value:0});
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/component-inventory/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentInventoryBtn").val("Update");
                        $("#CreateComponentInventoryBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    }

                    if (data.status == 'count_exist') {
                        self.$swal('',data.content,'info');
                        return;
                    }

                    if (data.status == "success") {

                            self.$router.push("/pdc-stock/list");

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentInventoryBtn").val("Update");
                        $("#CreateComponentInventoryBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'component-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }

    },

    loadItem() {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/component-inventory/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.itemId == null) {
                        self.component_id = null;
                    }else{
                        self.component_id = {value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode +")")};
                    }
                    self.selectedParts.push(self.component_id);

                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locationName)+' | '+data.content.locCode};
                    }

                     if(data.content.warehouse_id == null) {
                        self.warehouse_id = null;
                    }else{
                        self.warehouse_id = {value: data.content.warehouse_id, text: self.titleCase(data.content.warehouseCode)+' | '+data.content.warehouseName};
                        self.loadFieldData(['rsb'],self.warehouse_id.value);
                    }

                     if(data.content.stock_unit_id == null) {
                        self.stock_unit_id = null;
                    }else{
                        self.stock_unit_id = {value: data.content.stock_unit_id, text: self.titleCase(data.content.mstUnitCode)+' | '+data.content.mstUnitName};
                    }

                     if(data.content.purchase_unit_id == null) {
                        self.purchase_unit_id = null;
                    }else{
                        self.purchase_unit_id = {value: data.content.purchase_unit_id, text: self.titleCase(data.content.mUnitCode)+' | '+data.content.mUnitName};
                    }

                     if(data.content.warehouse_bin_mapper_id == null) {
                        self.rsb_id = null;
                    }else{
                        var row = '';
                        var shelf = '';
                        var bin = '';
                        if (data.content.location_row != null){
                            row = data.content.location_row;
                        }
                        if (data.content.location_shelf != null){
                            shelf = data.content.location_shelf;
                        }
                        if (data.content.location_bin != null){
                            bin = data.content.location_bin;
                        }
                        self.rsb_id = {value: data.content.warehouse_bin_mapper_id, text: row+' | '+shelf+' | '+bin};
                    }

                    if (data.content.onhand_min_qty == 0) {
                        self.onhand_min_qty = "";
                    } else{
                        self.onhand_min_qty = data.content.onhand_min_qty;
                    }
                    if (data.content.onhand_max_qty == 0) {
                        self.onhand_max_qty = "";
                    } else{
                        self.onhand_max_qty = data.content.onhand_max_qty;
                    }

                    if (data.content.is_default == 1) {
                        $("#is_default_warehouse").prop("checked",true);
                        self.is_default = true;
                    }else{
                        $("#is_default_warehouse").prop("checked",false);
                        self.is_default = false;
                    }
                    // if (data.content.location_bin == 0) {
                    //     self.location_bin = "";
                    // } else{
                    //     self.location_bin = data.content.location_bin;
                    // }

                    // self.location_shelf = data.content.location_shelf;
                    self.is_fuel_product = data.content.item_category_code === "FUEL" || data.content.item_category_code === "FUELNS";
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },

    changeLocation:function(){
        var self = this;
        if (self.selectedParts.length === 0){
          self.component_error_msg = "Select a part before selecting location!"
          self.location_id = null;
        }else{
          if (self.location_id != null && self.location_id.value){
            if (self.$route.params.id == undefined ){
              self.warehouse_id = '';
              self.rsb_id = '';
              self.onhand_min_qty = '';
              self.onhand_max_qty = '';
            }
            if (self.is_fuel_product){
              self.loadFieldData(['fuel_warehouse'],self.location_id.value);
            }else{
              self.loadFieldData(['non_fuel_warehouse'],self.location_id.value);
            }
          }
        }
    },

    changeWarehouse:function(){
        var self = this;

        if (self.warehouse_id != null && self.warehouse_id.value){
            self.loadFieldData(['rsb'],self.warehouse_id.value);
        }
    },
    isDefault(evt) {
        var self = this;
        if(evt.target.checked) {
            self.is_default = true;
            if (self.warehouseArr[0] != undefined){
                for(var i = 0;i<self.warehouseArr.length;i++){
                    if (self.warehouseArr[i].is_default != undefined && self.warehouseArr[i].is_default == 1){
                        self.warehouse_id = self.warehouseArr[i];
                        self.changeWarehouse();
                        return;
                    }
                }
            }
        }else{
            self.is_default = false;
        }
    },

    isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ComponentInventoryCreate.vue